module.exports = __webpack_public_path__ + "static/media/auth_background.52439365.png";